import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { connect } from 'react-redux';
import Layout from '@@client/app/Layout';
import Link from 'next/link';
import Markdown from '@@client/components/Markdown';
import SearchAndSlider, { Slide } from '@@client/home/SearchAndSlider';
import NewArrivals from '@@client/home/NewArrivals';
import FeaturedPartTypesSection from '@@client/home/FeaturedPartTypesSection';
import OurStuff from '@@client/home/OurStuff';
var Contact = connect(function (_ref) {
  var config = _ref.config;
  return {
    config: config
  };
}, function () {
  return {};
})(function (_ref2) {
  var config = _ref2.config;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "jsx-493746945" + " " + 'contact t-xs',
      children: [/*#__PURE__*/_jsx("div", {
        className: "jsx-493746945",
        children: /*#__PURE__*/_jsx("a", {
          href: "tel:".concat(config.contact.phoneFull),
          className: "jsx-493746945" + " " + 'btn btn--blue--light',
          children: config.contact.phoneHuman
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "jsx-493746945",
        children: /*#__PURE__*/_jsx(Link, {
          href: "/locations",
          children: /*#__PURE__*/_jsx("a", {
            className: "jsx-493746945" + " " + 'btn btn--blue--dark',
            children: "Store Locations"
          })
        })
      })]
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "493746945",
      children: [".contact.jsx-493746945{margin:0 10px 30px;}", "@media(max-width:575px){.contact.jsx-493746945{margin-bottom:17px;}}", ".contact.jsx-493746945 .btn{width:100%;}", ".contact.jsx-493746945>*.jsx-493746945{margin-bottom:13px;}", ".contact.jsx-493746945>*.jsx-493746945:last-child{margin-bottom:0;}"]
    })]
  });
});

function Index(_ref3) {
  var homepageContent = _ref3.homepageContent;
  var slides = homepageContent.slides || [];
  return /*#__PURE__*/_jsxs(Layout, {
    children: [/*#__PURE__*/_jsx(SearchAndSlider, {
      children: slides.map(function (slide) {
        return /*#__PURE__*/_jsx(Slide, {
          imageUrl: slide.backgroundImage.url,
          alt: slide.backgroundImage.alternativeText,
          heading: slide.title,
          subContent: slide.subContent ? /*#__PURE__*/_jsx(Markdown, {
            children: slide.subContent
          }) : null,
          children: /*#__PURE__*/_jsx(Markdown, {
            children: slide.content
          })
        }, slide.id);
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "jsx-1497013674" + " " + 'gray-bg',
      children: [/*#__PURE__*/_jsx(FeaturedPartTypesSection, {
        title: homepageContent.categoriesTitle,
        description: homepageContent.categoriesDescription
      }), /*#__PURE__*/_jsx(Contact, {}), /*#__PURE__*/_jsx(NewArrivals, {})]
    }), /*#__PURE__*/_jsx("div", {
      className: "jsx-1497013674" + " " + 'white-bg',
      children: /*#__PURE__*/_jsx(OurStuff, {})
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "1497013674",
      children: [".gray-bg.jsx-1497013674{position:relative;background:#F0F1F6;padding:30px 0;}", "@media(max-width:575px){.gray-bg.jsx-1497013674{padding:17px 0;}}", ".gray-bg.jsx-1497013674::before{content:'';position:absolute;display:none;width:100%;height:19px;top:0;left:0;background:-webkit-gradient(linear,left top,left bottom,from(#666C82),to(#F0F1F6));background:linear-gradient(#666C82,#F0F1F6);opacity:0.5;}", "@media(min-width:576px){.gray-bg.jsx-1497013674::before{display:block;}}", "@media(min-width:576px){.white-bg.jsx-1497013674{padding:30px 0;}}", "@media(min-width:576px) and (max-width:575px){.white-bg.jsx-1497013674{padding:17px 0;}}"]
    })]
  });
}

export var __N_SSP = true;
export default Index;